import { FieldDef } from '@core/models';

/** Shape accepted wherever we only need `meta.thousands_separator`. */
export type FieldThousandsMeta = Pick<FieldDef, 'meta'> | { meta?: FieldDef['meta'] };

/**
 * Options for accounting-js `formatNumber`. When `meta.thousands_separator === false`, omit grouping.
 * Undefined/true keeps the previous default (comma thousands separator).
 */
export function accountingNumberFormatOptions(
  precision: number,
  fieldDef?: FieldThousandsMeta,
): { precision: number; thousand: string } {
  return {
    precision,
    thousand: fieldDef?.meta?.thousands_separator === false ? '' : ',',
  };
}
